import axios from 'axios'
import { pumatracApi } from '../utils/axios-config'

export {default as workout} from './workout'
export {default as users} from './users'
export {default as profiles} from './profiles'
export {default as opportunities} from './opportunities'


export function trainers () {
    return pumatracApi.get('/trainers/')
}

export function goals () {
    return pumatracApi.get('/goals/')
}

export function interests () {
    return pumatracApi.get('/interests/')
}

export function presign () {
    return pumatracApi.get('/presign/')
}

export function postToS3 (params, file) {
    let formData = new FormData();
    let data = {
        ...params.fields,
        file: file
    }
    for ( var key in data ) {
        formData.append(key, data[key]);
    }
    let config = {
        url: params.url,
        method: params.method,
        data: formData,
        headers: params.headers,
    };
    return axios(config);
}

